/*
 * View for the downloading display
 */

define(["marionette", "modules/downloadDisplay/template/downloadDisplayTemplate.html"], function (
  Marionette,
  DownloadDisplayTemplate,
) {
  var DownloadDisplayView = {};

  DownloadDisplayView.downloadDisplayLayout = Marionette.Layout.extend({
    template: DownloadDisplayTemplate,
    regions: {
      progressBar: "#progressBar",
    },
  });

  return DownloadDisplayView;
});
